import { registerDropIndicatorElement } from '@prosekit/web/drop-indicator'

export * from '@prosekit/web/drop-indicator'

export { DropIndicatorElement as DropIndicator } from '@prosekit/web/drop-indicator'

registerDropIndicatorElement()
